import React, { useState, useEffect } from "react";
import { DocumentApi } from "../services/ApiService";
import { UsageEventsTracker } from "../services/UsageEventsTracker";
import "./SearchBar.css"; // Optional: add dedicated SearchBar styles

console.log("✅ SearchBar.js is being loaded!");

const SearchBar = ({ onSearchResults }) => {
  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    // Track search view
    UsageEventsTracker.recordPageView('/search');
  }, []);

  const handleSearch = () => {
    if (!query.trim()) {
      setError("Please enter a search term");
      return;
    }

    setLoading(true);
    setError("");

    // Start correlation for this search flow
    const corrId = UsageEventsTracker.startCorrelation('search');

    // Track search execution
    UsageEventsTracker.recordUserAction('SEARCH_QUERY', {
      action: 'execute',
      category: 'search',
      label: 'search_query',
      metadata: {
        query: query.substring(0, 100), // Truncate for privacy
        filter,
        sortOrder
      }
    }, { correlationId: corrId });

    const options = {
      sort: sortOrder,
      page: 0,
      size: 10,
    };

    DocumentApi.searchDocuments(query, options)
      .then((response) => response.json())
      .then((data) => {
        const results = data.results || data;
        onSearchResults(results);
        setLoading(false);
        
        // Track search results
        UsageEventsTracker.recordUserAction('SEARCH_RESULTS', {
          action: 'view',
          category: 'search',
          label: 'results_received',
          value: Array.isArray(results) ? results.length : 0,
          metadata: {
            resultCount: Array.isArray(results) ? results.length : 0,
            query: query.substring(0, 100)
          }
        }, { correlationId: UsageEventsTracker.getCorrelation('search') });
        UsageEventsTracker.clearCorrelation('search');
      })
      .catch((err) => {
        setError("Search failed. Try again.");
        console.error("Search error:", err);
        setLoading(false);
        
        // Track search error
        UsageEventsTracker.recordUserAction('SEARCH_ERROR', {
          action: 'error',
          category: 'search',
          label: 'search_failed',
          metadata: {
            errorMessage: err.message
          }
        }, { correlationId: UsageEventsTracker.getCorrelation('search') });
        UsageEventsTracker.clearCorrelation('search');
      });
  };

  return (
    <div className="search-bar">
      <h2>Search Metadata</h2>
      <div className="search-controls">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search query..."
          className="search-input"
        />
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="search-select"
        >
          <option value="">All</option>
          <option value="type">Type</option>
          <option value="size">Size</option>
          {/* Add more filter options as needed */}
        </select>
        <select
          value={sortOrder}
          onChange={(e) => setSortOrder(e.target.value)}
          className="search-select"
        >
          <option value="asc">Ascending</option>
          <option value="desc">Descending</option>
        </select>
        <button
          onClick={handleSearch}
          disabled={loading}
          className="search-btn"
        >
          {loading ? "Searching..." : "Search"}
        </button>
      </div>
      {error && <p className="search-error">{error}</p>}
    </div>
  );
};

export default SearchBar;
